import React, {lazy, Suspense} from 'react'

const SpaceOrganizationLazy = lazy(() =>
    import('./SpaceOrganization')
)

const SpaceOrganization = props => (
    <Suspense fallback={null}>
        <SpaceOrganizationLazy {...props} />
    </Suspense>
)

export default SpaceOrganization
